import { useConfig } from '@context/ConfigurationContext'
import { Variants } from 'src/lib'

export const useCityVariantData = () => {
  const { variant } = useConfig()

  let cityName: string | undefined
  let treatmentBundleTypeReferenceId: string | undefined

  if (variant?.type === Variants.City) {
    cityName = variant.cityName
    treatmentBundleTypeReferenceId = variant.treatmentBundleTypeReferenceId
  }

  return { cityName, treatmentBundleTypeReferenceId }
}
